import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestViewComponent } from './test-view/test-view.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import {ViewModule} from "../views/view.module";

@NgModule({
	imports: [
	CommonModule,
		NgbModule,
		ViewModule
	],
	declarations: [TestViewComponent]
})
export class TestModule { }
